<template>
  <div class="main" @click.self="$emit('close')">
    <form class="box-modal" @submit.prevent="submit">
      <span class="title">تغییر رمز عبور</span>
      <!-- <custom-input type="password" placeholder="رمز عبور فعلی"/> -->
      <p>لطفا یک رمز عبور مناسب  برای حساب کاربری خود انتخاب کنید.</p>
      <div class="public-input">
        <input   placeholder="رمزعبور فعلی"
            @input="passError = ''"
          v-model="oldpassword"
             :type="password0 ? 'password' : 'text'"
        
        
        >
        <img :src="require('@/assets/icon/input/password.svg')" alt=""   @click="password0 = !password0">
      </div>
            <div class="public-input">
        <input  :type="password1 ? 'password' : 'text'"  placeholder="رمزعبور جدید"
            @input="pass1Error = ''"
          v-model="newpassword1"
        >
        <img :src="require('@/assets/icon/input/password.svg')" alt=""   @click="password1 = !password1">
      </div>
            <div class="public-input">
        <input  
            :type="password2 ? 'password' : 'text'"
          placeholder=" تکرار رمز عبور جدید "
          @input="pass2Error = ''"
          v-model="newpassword2"
        
        
        
        >
        <img :src="require('@/assets/icon/input/password.svg')" alt=""     @click="password2 = !password2">
      </div>
      <!-- <custom-input type="password" placeholder="رمز عبور جدید"/> -->

      <button  class="blue-btn"
             type="submit"
        :disabled="!oldpassword || !newpassword1 || !newpassword2"
      
      >تایید</button>
    </form>
  </div>
</template>

<script>
import CustomInput from "../../../tools/custom-input";
export default {
  name: "change-pass",
  components: {CustomInput}
  ,
  data() {
    return {
      oldpassword: "",
      newpassword1: "",
      newpassword2: "",
      passError: "",
      pass1Error: "",
      pass2Error: "",
      password0: true,
      password1: true,
      password2: true,
    };
  },
  methods: {
    async submit() {
      let passSent = {
        oldPassword: this.oldpassword,
        password: this.newpassword1,
      };
      await this.check2Pass();
      if (this.newpassword1 && this.newpassword2) {
        if (this.checkPass()) this.state.loading = true;
        try {
          const res = await this.$axios.post(
            `/users/change-password`,
            passSent
          );
          if (res.message === "password changed successfully") {
            this.$error("رمز شما تغییر یافت", "", "success");
            this.oldpassword = "";
            this.newpassword1 = "";
            this.newpassword2 = "";
            this.$emit('close')
          }

        } catch (error) {
          if (error.response.data.message === "Old Password Is Incorrect") {
            this.passError = "رمز قبلی اشتباه است.";
          }
        }
      }
    },
    checkPass() {
      if (!this.oldpassword) {
        this.passError = "رمز فعلی اجباری";
      } else {
        this.passError = "";
      }
      if (this.newpassword1) {
        if (this.newpassword1.length < 8) {
          this.pass1Error = "حداقل 8 کاراکتر";
        } else if (!this.validPass(this.newpassword1)) {
          this.pass1Error = "ترکیبی از حروف کوچک و بزرگ و عدد";
        } else if (!this.newpassword2) {
          this.pass1Error = "";
          this.pass2Error = "تکرار رمز اجباری";
        } else if (this.newpassword2 !== this.newpassword1) {
          this.pass1Error = "";
          this.pass2Error = "تکرار رمز مطابقت ندارد";
        } else {
          this.pass2Error = "";
        }
      }
      if (
        !this.passError.length &&
        !this.pass1Error.length &&
        !this.pass2Error.length
      ) {
        return true;
      }
    },
    async check2Pass() {
      if (!this.$validPass(this.oldpassword) || this.oldpassword.length < 8) {
        this.$error(
          "اطلاعات وارد شده اشتباه است",
          "رمز باید حداقل 8 کاراکتر باشد و شامل حرف بزرگ ، حرف کوچک و عدد باشد"
        );
        return Promise.reject("wrong pass : " + this.oldpassword);
      }
      if (this.newpassword1 !== this.newpassword2) {
        this.$error("اطلاعات وارد شده اشتباه است", "تکرار رمز اشتباه است");
        return Promise.reject(
          "repeat failed : " + this.newpassword1 + "!==" + this.newpassword2
        );
      }
    },
    validPass(password) {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
      return re.test(password);
    },
  },
}
</script>

<style lang="scss" scoped>
.public-input {
display: flex;
align-items: center;
justify-content: space-between;
    border: 1px solid #8C8585;
    box-sizing: border-box;
    border-radius: 8px;
    color: rgba(140, 133, 133, 1);
    // text-align: right;
    height: 40px;
    padding: 0 10px;
    input{
      color:white;
    }
    /* width: 100%; */
}







.main {
  
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

.box-modal {
width: 20%;
min-width: 200px;
background-color: rgba(11, 20, 38, 1);
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 28px;
    gap: 20px;





    .title{
      font-size: clamp(14px , 2vw , 16px);
      color: #FFFFFF;
      font-weight: bold;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 28px;
    }

  }
}
</style>